// import "./header.css";

// import { HandySvg } from "handy-svg";
// import iconSrc from "../../../svg/logo.svg";
// import MainPop from "../../popUp/mainPop";
// import { useState } from "react";

// export default function Logo() {
//   const [popUp, setPopUp] = useState(false);
//   const handleMouseEnter = () => {
//     setPopUp(true);
//   };

//   const handleMouseLeave = () => {
//     setPopUp(false);
//   };

//   return (
//     <>
//       <div className="wrapLogo">
//         <HandySvg
//           src={iconSrc}
//           width="129.63"
//           height="120.33"
//           onMouseEnter={handleMouseEnter}
//           onMouseLeave={handleMouseLeave}
//         />
//         <h1 className="logoH1">
//           Видавництво
//           <br />
//           <span>ЧАС МАЙСТРІВ</span>
//         </h1>
//       </div>
//       {popUp && <MainPop />}
//     </>
//   );
// }
import "./header.css";
import { HandySvg } from "handy-svg";
import iconSrc from "../../../svg/logo.svg";
import MainPop from "../../popUp/mainPop";
import { useEffect, useId, useRef, useState } from "react";
import MainPopForH from "../../popUp/mainPopForH";
import css from "./logo.module.css";

export default function Logo() {
  const [activePopup, setActivePopup] = useState(null);
  const triggerRef = useRef(null);
  const popupRef = useRef(null);
  const touchGesture = useRef(null);
  const popupId = useId();

  const isMouseHover = (event) =>
    event.pointerType === "mouse" &&
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  const handlePointerDown = (event) => {
    touchGesture.current = event.pointerType === "touch" || event.pointerType === "pen"
      ? { x: event.clientX, y: event.clientY, moved: false }
      : null;
  };

  const handlePointerMove = (event) => {
    const gesture = touchGesture.current;
    if (gesture && Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 10) {
      gesture.moved = true;
    }
  };

  const handlePointerCancel = () => {
    if (touchGesture.current) touchGesture.current.moved = true;
  };

  const togglePopup = (popup, event) => {
    event.preventDefault();
    event.stopPropagation();
    // Ignore a compatibility click generated at the end of a touch scroll.
    if (event.detail !== 0 && touchGesture.current?.moved) {
      return;
    }
    setActivePopup((current) => current === popup ? null : popup);
  };

  const closeOnMouseLeave = (event, destinationRef) => {
    if (!isMouseHover(event)) return;
    const destination = event.relatedTarget;
    if (!(destination instanceof Node) || !destinationRef.current?.contains(destination)) {
      setActivePopup(null);
    }
  };

  useEffect(() => {
    if (!activePopup) return;

    const handleOutsidePointerDown = (event) => {
      if (!triggerRef.current?.contains(event.target) && !popupRef.current?.contains(event.target)) {
        setActivePopup(null);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setActivePopup(null);
    };
    const handleScroll = () => setActivePopup(null);

    document.addEventListener("pointerdown", handleOutsidePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      document.removeEventListener("pointerdown", handleOutsidePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activePopup]);

  return (
    <>
      <div className="wrapLogo" ref={triggerRef}>
        <button
          type="button"
          className={`${css.trigger} ${css.birdTrigger}`}
          aria-label="Про символ видавництва"
          aria-expanded={activePopup === "logo"}
          aria-controls={activePopup === "logo" ? popupId : undefined}
          onPointerEnter={(event) => {
            if (isMouseHover(event)) setActivePopup("logo");
          }}
          onPointerLeave={(event) => closeOnMouseLeave(event, popupRef)}
          onPointerDown={handlePointerDown}
          onPointerMove={handlePointerMove}
          onPointerCancel={handlePointerCancel}
          onClick={(event) => togglePopup("logo", event)}
        >
          <HandySvg src={iconSrc} width="129.63" height="120.33" />
        </button>
        <h1 className="logoH1">
          <button
            type="button"
            className={css.trigger}
            aria-expanded={activePopup === "title"}
            aria-controls={activePopup === "title" ? popupId : undefined}
            onPointerEnter={(event) => {
              if (isMouseHover(event)) setActivePopup("title");
            }}
            onPointerLeave={(event) => closeOnMouseLeave(event, popupRef)}
            onPointerDown={handlePointerDown}
            onPointerMove={handlePointerMove}
            onPointerCancel={handlePointerCancel}
            onClick={(event) => togglePopup("title", event)}
          >
            Видавництво
            <br />
            <span>ЧАС МАЙСТРІВ</span>
          </button>
        </h1>
      </div>

      {activePopup && (
        <div
          id={popupId}
          ref={popupRef}
          role="region"
          aria-label={activePopup === "logo" ? "Про символ видавництва" : "Місія видавництва"}
          onPointerLeave={(event) => closeOnMouseLeave(event, triggerRef)}
        >
          {activePopup === "logo" ? <MainPop /> : <MainPopForH />}
        </div>
      )}
    </>
  );
}
